/**
 * Removes any properties from an object that are not standard HTML attributes.
 * This helps prevent invalid HTML attributes and avoids console errors, as
 * some props that are passed to components may spread into DOM elements.
 *
 * @param {Object.<string, any>} props
 * @param {Array<string>} additional
 * @return {Object.<string, any>}
 */
export const stripNonHtmlProps = (props, additional = []) => {
  const invalidKeys = [
    'CmsComponents',
    'ScrollIndexVertical',
    'containerDimension',
    'groupTheme',
    'isSlider',
    'trackingName',
    'linkTitle',
    ...additional.filter(val => typeof val === 'string'),
  ];

  return Object.keys(props).reduce((newProps, key) => {
    if (!invalidKeys.includes(key)) {
      newProps[key] = props[key];
    }

    return newProps;
  }, {});
};
